import { Card, Label, Layout, Text, TextField } from '@loadsmart/loadsmart-ui'
import GatewaySettingsSelector from 'common/components/selectors/GatewaySettingsSelector'
import { IntegrationTestCaseDetail } from 'common/types/kraken-core/IntegrationTest'

export interface IntegrationTestCaseDetailEntryPointProps {
  testCase: IntegrationTestCaseDetail
  onChange: (propertyName: string, value: any) => void
}

export default function IntegrationTestCaseDetailEntryPoint(
  props: IntegrationTestCaseDetailEntryPointProps
) {
  const testCase = props.testCase

  return (
    <Card>
      <Card.Title>
        <Layout.Stack>
          <Text variant="heading-sm-bold">Entry Point</Text>
          <Text variant="body">To define where the test will start</Text>
        </Layout.Stack>
      </Card.Title>
      <Card.Separator />
      <Card.Body>
        <Layout.Stack>
          <Layout.Stack space="s">
            <Label required>Input Gateway</Label>
            <GatewaySettingsSelector
              selected={{
                id: testCase.input_gateway,
                label: testCase.input_gateway,
              }}
              onSelect={selected => {
                if (selected) props.onChange('input_gateway', selected.id)
              }}
            />
          </Layout.Stack>

          <Layout.Stack space="s">
            <Label required>Input Route</Label>
            <TextField
              name="input_route"
              value={testCase.input_route}
              onChange={e => props.onChange(e.target.name, e.target.value)}
            />
          </Layout.Stack>
        </Layout.Stack>
      </Card.Body>
    </Card>
  )
}
